import {
    Carousel,
    CaseListComponent,
    CaseIntro,
    ClientBar,
    Comparison,
    ContactBar,
    ContactPerson,
    DescriptionPlusText,
    DescriptionPlusCaselist,
    DescriptionPlusContact,
    FeaturedCaseComponent,
    FeaturedPageLink,
    Footer,
    FrontCaseList,
    FullscreenMedia,
    GetInTouch,
    GoertekSlider,
    GoertekTypeset,
    GoertekVisualizer,
    HeroImage,
    HeroText,
    HeroTextCase,
    HeroThoughts,
    HeroVideo,
    HeroServices,
    Iframe,
    JobsList,
    LayoutLine,
    LargeMedia,
    LetsFightAverage,
    LinkBar,
    MailchimpForm,
    MarkdownText,
    NextCase,
    PersonList,
    Quote,
    SideBySideMedia,
    SideBySideText,
    SideBySideTextCarousel,
    SideBySideTextMedia,
    SmallMedia,
    Spacer100,
    Spacer200,
    Spacer300,
    Text,
    TextWithFilters,
    TextSection,
    TextListItem,
    TextWithBackground,
    ThoughtFeaturedCase,
    ThoughtHeaderComponent,
    ThoughtsList,
    ThreeColumnText,
    TypeTester,
} from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';

class Modules extends PureComponent {
    constructor(props) {
        super(props);

        this.modules = {
            DatoCmsCaseList(props, data) {
                return <CaseListComponent {...props} cases={data.cases} />;
            },
            DatoCmsComparison(props, data) {
                return (
                    <Comparison
                        {...props}
                        pageBackgroundColor={
                            props.backgroundColor || data.page.backgroundColor
                        }
                    />
                );
            },
            DatoCmsCaseSection(props) {
                return <div id={props.id} />;
            },
            DatoCmsCaseIntro(props) {
                return <CaseIntro {...props} />;
            },
            DatoCmsDescriptionPlusText(props) {
                return <DescriptionPlusText {...props} />;
            },
            DatoCmsDescriptionPlusCaseList(props) {
                return <DescriptionPlusCaselist {...props} />;
            },
            DatoCmsDescriptionPlusContact(props) {
                return <DescriptionPlusContact {...props} />;
            },
            DatoCms3ColumnText(props) {
                return <ThreeColumnText {...props} />;
            },
            DatoCmsCarousel(props) {
                return <Carousel {...props} />;
            },
            DatoCmsContactPerson(props) {
                return <ContactPerson {...props} />;
            },
            DatoCmsFeaturedCase(props) {
                return <FeaturedCaseComponent {...props} />;
            },
            DatoCmsFeaturedPageLink(props) {
                return <FeaturedPageLink {...props} />;
            },
            DatoCmsGoertekVisualizer(props) {
                return <GoertekVisualizer {...props} />;
            },
            DatoCmsGoertekSlider(props) {
                return <GoertekSlider {...props} />;
            },
            DatoCmsGoertekTypeset(props) {
                return <GoertekTypeset {...props} />;
            },
            DatoCmsLayoutLine(props) {
                return <LayoutLine {...props} />;
            },
            DatoCmsSideBySideText(props, data) {
                return <SideBySideText {...props} jobs={data.jobs} />;
            },
            DatoCmsSideBySideTextImage(props, data) {
                return <SideBySideTextMedia {...props} jobs={data.jobs} />;
            },
            DatoCmsSideBySideImage(props) {
                return <SideBySideMedia {...props} />;
            },
            DatoCmsSideBySideTextCarousel(props, data) {
                return <SideBySideTextCarousel {...props} jobs={data.jobs} />;
            },
            DatoCmsServicesHero(props) {
                return <HeroServices {...props} />;
            },
            DatoCmsHeroContentsThoughtsText(props) {
                return <HeroThoughts {...props} />;
            },
            DatoCmsHeroImage(props) {
                return <HeroImage {...props} />;
            },
            DatoCmsHeroVideo(props) {
                return <HeroVideo {...props} />;
            },
            DatoCmsHeroText(props) {
                return <HeroText {...props} />;
            },
            DatoCmsCaseHeroText(props, data) {
                return (
                    <HeroTextCase
                        {...props}
                        client={data.client}
                        tag={data.tags.length && data.tags[0].tag}
                        year={data.date && data.date.split('-')[0]}
                    />
                );
            },
            DatoCmsGetInTouch(props) {
                return <GetInTouch {...props} />;
            },
            DatoCmsLinkBar(props) {
                return <LinkBar {...props} />;
            },
            DatoCmsViewsNewsList(props) {
                return <ThoughtsList {...props} />;
            },
            DatoCmsNextCase(props) {
                return <NextCase {...props} />;
            },
            DatoCmsContentsLetsFightAvarage(props) {
                return <LetsFightAverage {...props} />;
            },
            DatoCmsLargeVideoImage(props) {
                return <LargeMedia {...props} />;
            },
            DatoCmsJobsList(props) {
                return <JobsList {...props} />;
            },
            DatoCmsSmallVideoImage(props) {
                return <SmallMedia {...props} />;
            },
            DatoCmsContactBar(props, data) {
                return <ContactBar {...props} {...data.contactBar} />;
            },
            DatoCmsContentsCasesList(props) {
                return <FrontCaseList {...props} />;
            },
            DatoCmsContentsText(props) {
                return <Text {...props} />;
            },
            DatoCmsTextSection(props) {
                return <TextSection {...props} />;
            },
            DatoCmsTextWithBackground(props) {
                return <TextWithBackground {...props} />;
            },
            DatoCmsMarkdownText(props) {
                return <MarkdownText {...props} />;
            },
            ThoughtHeaderComponent(props) {
                return <ThoughtHeaderComponent {...props} />;
            },
            DatoCmsNewsFeaturedCase(props) {
                return <ThoughtFeaturedCase {...props} />;
            },
            DatoCmsTextListItem(props) {
                return <TextListItem {...props} />;
            },
            DatoCmsFullscreenVideoImage(props) {
                return <FullscreenMedia {...props} />;
            },

            DatoCmsClientbar(props) {
                return <ClientBar {...props} />;
            },
            DatoCmsPeopleList(props) {
                return <PersonList {...props} />;
            },
            DatoCmsTypetester(props) {
                return <TypeTester {...props} />;
            },
            DatoCmsSpacer100(props) {
                if (props.size) {
                    return <div className="spacer" size={props.size}></div>;
                }
                return <Spacer100 {...props} />;
            },
            DatoCmsSpacer200(props) {
                return <Spacer200 {...props} />;
            },
            DatoCmsSpacer300(props) {
                return <Spacer300 {...props} />;
            },
            DatoCmsQuote(props) {
                return <Quote {...props} />;
            },
            DatoCmsIframe(props) {
                return <Iframe {...props} />;
            },
            DatoCmsWorkTextWithFilter(props, data) {
                return <TextWithFilters {...props} {...data.footer} />;
            },
            DatoCmsFooter(props, data) {
                return <Footer {...props} {...data.footer} />;
            },
            DatoCmsMailchimpForm(props) {
                return <MailchimpForm {...props} />
            }
        };
    }

    render() {
        let { content, data, heroOnLoad } = this.props;

        content.heroOnLoad = heroOnLoad;

        let imageBackgroundColor = _get(
            data,
            'page.imageBackgroundColor',
            null
        );
        if (!content.imageBackgroundColor) {
            content.imageBackgroundColor = imageBackgroundColor;
        }

        if (!(content && this.modules[content.__typename])) {
            console.log('Missing', this.props);
        }
        return content && this.modules[content.__typename]
            ? this.modules[content.__typename](content, data)
            : '';
    }
}

export default Modules;
